import { useQuery } from "@tanstack/react-query";
import type { Schemas } from "@softmax/observatory-client/types";
import { useDiscardUnavailableData } from "../data/use-discard-unavailable-data";
import { actualViewerQueryOptions } from "./viewer.queries";

type ActualUserViewer = Schemas["WhoAmIResponse"] & {
  readonly subject_type: "user";
  readonly subject_id: string;
};

export function useActualViewer() {
  const options = actualViewerQueryOptions();
  const viewer = useQuery({
    ...options,
    select: (principal): ActualUserViewer | null => {
      if (principal.subject_type !== "user" || !principal.subject_id)
        return null;

      return {
        ...principal,
        subject_type: "user",
        subject_id: principal.subject_id,
      };
    },
  });
  const unavailable = useDiscardUnavailableData({
    queryKey: options.queryKey,
    error: viewer.error,
  });

  if (viewer.isError && unavailable) return { ...viewer, data: undefined };

  return viewer;
}
